import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ArrowDown } from 'lucide-react';
export function Hero() {
  const handleCTAClick = () => {
    window.location.href = 'https://cuerpoencalma.it.com/cart/49295445262573:1';
  };
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-[90vh] flex items-center justify-center pt-20 pb-16 px-4 overflow-hidden bg-cream-100" data-id="element-10">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-11">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} className="space-y-8 text-center md:text-left" data-id="element-12">
          <div className="inline-block px-4 py-1.5 bg-terracotta/10 text-terracotta font-medium rounded-full text-sm tracking-wide" data-id="element-13">
            PARA MUJERES 30-44 AÑOS
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-brown leading-tight" data-id="element-14">
            En 7 días: menos hinchazón, más{' '}
            <span className="text-terracotta italic" data-id="element-15">"ropa cómoda"</span>.
          </h1>

          <p className="text-xl text-brown-light leading-relaxed max-w-lg mx-auto md:mx-0" data-id="element-16">
            No es grasa. Es hinchazón. Y se baja distinto. El plan
            office-friendly para desinflamar sin vivir a dieta.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start pt-4" data-id="element-17">
            <Button onClick={handleCTAClick} data-id="element-18">Quiero el Reset de 7 Días</Button>
          </div>

          <p className="text-sm text-brown-light/80 italic" data-id="element-19">
            *Sin detox. Sin reglas imposibles. Sin obsesión.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative" data-id="element-20">
          <div className="absolute inset-0 bg-terracotta/5 rounded-full blur-3xl transform scale-90" data-id="element-21" />
          <img src="https://cdn.magicpatterns.com/uploads/7XYeuAkAqeSS9L1bFf8a33/HINCHAZON.png" alt="Reset de Hinchazón en iPad" className="relative z-10 w-full h-auto rounded-2xl shadow-2xl transform rotate-1 hover:rotate-0 transition-transform duration-500" data-id="element-22" />
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1,
      duration: 1
    }} className="absolute bottom-8 left-1/2 -translate-x-1/2 text-terracotta animate-bounce" data-id="element-23">
        <ArrowDown size={24} data-id="element-24" />
      </motion.div>
    </section>;
}